// The ONLY components that re-render on playhead ticks. The playhead left the shared
// timeline context (a 60fps context value re-rendered every consumer for a whole
// playback); these widgets subscribe via useReelPlayhead and repaint alone.

import { useReelPlayhead, type VideoTimelineContextValue } from './CompositionEditorProvider'
import { fmtTC } from './ReelTimeline'

type TimeSource = Pick<VideoTimelineContextValue, 'getCurrentTime' | 'subscribeTime'>

/** The timeline's vertical playhead line (ruler + all lanes). */
export function PlayheadLine({ timeline, pxPerSec }: { timeline: TimeSource; pxPerSec: number }) {
  const t = useReelPlayhead(timeline)
  return (
    <div
      className="pointer-events-none absolute top-0 bottom-0 z-20"
      style={{ left: t * pxPerSec }}
    >
      <div className="h-full w-px bg-acid" />
      <div className="absolute -top-0.5 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 bg-acid" />
    </div>
  )
}

/** The transport's live "current / total" readout. */
export function ReelTimecode({
  timeline,
  total,
  className,
}: {
  timeline: TimeSource
  total: number
  className?: string
}) {
  const t = useReelPlayhead(timeline)
  return (
    <span className={className}>
      {fmtTC(t)} / {fmtTC(total)}
    </span>
  )
}
